import amplitude from 'amplitude-js';
import { PAGE_VIEW, TAP_STORE, IOS, ANDROID, OPEN_MARKER, CHANGE_TILE } from '@/constants';
import { TILE_ACTION_TO_TYPE, TileAction } from '@/types';

const AnaliticsHelpers = () => {
  const pageViewAnalitics = (pageName: string, data?: Record<string, unknown>) => {
    const event = PAGE_VIEW;
    const eventProperties = {
      page: pageName,
      ...(data || {}),
    };
    amplitude.getInstance().logEvent(event, eventProperties);
  };

  const marketClickAnalitics = (name: string) => {
    const event = TAP_STORE;
    const eventProperties = {
      market: name === IOS ? IOS : ANDROID,
    };
    amplitude.getInstance().logEvent(event, eventProperties);
  };

  const openMarkerAnalitics = (isStation: boolean) => {
    const eventProperties = {
      isStation,
    };
    amplitude.getInstance().logEvent(OPEN_MARKER, eventProperties);
  };

  const changeTileAnalitics = (name: string) => {
    const tileType = TILE_ACTION_TO_TYPE[name as TileAction];

    const eventProperties = {
      tile: tileType || name,
    };
    amplitude.getInstance().logEvent(CHANGE_TILE, eventProperties);
  };

  return {
    pageViewAnalitics,
    marketClickAnalitics,
    openMarkerAnalitics,
    changeTileAnalitics,
  };
};

export default AnaliticsHelpers;


